import { Dropdown } from "antd";
import classNames from "classnames";
import { useCallback } from "react";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import styles from "./index.module.less";

export default function ShareDropdown({ children, pics, title, ...props }) {
  const onShare = (type) => {
    const url = window.location.href;

    let link;
    if (type === "weibo") {
      if (Array.isArray(pics)) {
        pics = pics.join("||");
      }

      const appkey = "2499394483";
      const ralateUid = "2493118952";

      link = `http://service.weibo.com/share/share.php?url=${encodeURIComponent(
        `${url}${
          url.indexOf("?") !== -1 ? "&" : "?"
        }utm_source=js-share&utm_medium=weibo`
      )}&appkey=${appkey}&pic=${pics}&title=${title}&ralateUid=${ralateUid}`;
    } else if (type === "qzone") {
      if (Array.isArray(pics)) {
        pics = pics.join("|");
      }
      link = `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
        `${url}${
          url.indexOf("?") !== -1 ? "&" : "?"
        }utm_source=js-share&utm_medium=qzone`
      )}&title=${title}&pics=${pics}`;
    } else if (type === "qq") {
      if (Array.isArray(pics)) {
        pics = pics.join("|");
      }
      link = `http://connect.qq.com/widget/shareqq/index.html?&url=${encodeURIComponent(
        `${url}${
          url.indexOf("?") !== -1 ? "&" : "?"
        }utm_source=js-share&utm_medium=qfriends`
      )}&title=${title}&pic=${pics}&site=${encodeURIComponent("花瓣网")}`;
    } else if (type === "douban") {
      if (Array.isArray(pics)) {
        if (pics.length) {
          pics = pics[0];
        } else {
          pics = "";
        }
      }
      link = `http://www.douban.com/recommend/?url=${encodeURIComponent(
        `${url}${
          url.indexOf("?") !== -1 ? "&" : "?"
        }utm_source=js-share&utm_medium=douban`
      )}&title=${title}&image=${pics}&comment=${title}`;
    }

    window.open(link, "_blank", "noreferrer");
  };

  const onCopy = useCallback(() => {
    const url = window.location.href;
    let shareUrl = url;

    // 检查 URL 是否已包含 from 或 share_text 参数
    if (!url.includes("from=") && !url.includes("share_text=")) {
      shareUrl = `${url}${
        url.indexOf("?") !== -1 ? "&" : "?"
      }from=share&share_text=`;
    }

    // 直接使用纯文本，但分两行显示，这样在地址栏粘贴时只会使用第一行的 URL
    navigator.clipboard.writeText(`${shareUrl}\r\n${title}`).then(() => {
      HBMessage.success("复制链接成功");
    });
  }, [title]);

  const menu = (
    <div
      className={styles.menu}
      data-gd-expose="dialog_expose"
      data-dialog-title="分享"
      data-module_name="分享"
    >
      <div className={styles.header}>
        <a
          className={styles.menuItem}
          onClick={onCopy}
          data-gd-click="button_click"
          data-button-name="复制分享链接"
          data-pin-detail
        >
          <HBIcon
            className={classNames([styles.icon, styles.copy])}
            type="ic_link"
          />
          <span className={styles.text}>复制分享链接</span>
        </a>
      </div>
      <div className={styles.body}>
        <a
          className={styles.menuItem}
          onClick={() => onShare("weibo")}
          data-gd-click="button_click"
          data-button-name="分享到微博"
          data-pin-detail
        >
          <HBIcon
            className={classNames([styles.icon, styles.weibo])}
            type="ic_xl1"
          />
          <span className={styles.text}>分享到微博</span>
        </a>
        <a
          className={styles.menuItem}
          onClick={() => onShare("qzone")}
          data-gd-click="button_click"
          data-button-name="分享到QQ空间"
          data-pin-detail
        >
          <HBIcon
            className={classNames([styles.icon, styles.qzone])}
            type="ic_qqzone"
          />
          <span className={styles.text}>分享到QQ空间</span>
        </a>
        <a
          className={styles.menuItem}
          onClick={() => onShare("qq")}
          data-gd-click="button_click"
          data-button-name="分享到QQ"
          data-pin-detail
        >
          <HBIcon
            className={classNames([styles.icon, styles.qq])}
            type="ic_qq1"
          />
          <span className={styles.text}>分享到QQ</span>
        </a>
        <a
          className={styles.menuItem}
          onClick={() => onShare("douban")}
          data-gd-click="button_click"
          data-button-name="分享到豆瓣"
          data-pin-detail
        >
          <HBIcon
            className={classNames([styles.icon, styles.douban])}
            type="ic_db"
          />
          <span className={styles.text}>分享到豆瓣</span>
        </a>
      </div>
    </div>
  );

  return (
    <Dropdown overlay={menu} {...props}>
      {children}
    </Dropdown>
  );
}
